export const ENTRY_TYPES = ['pee', 'poo'];

export const TYPE_LABELS = {pee: 'Pee', poo: 'Poo'};

// Entries recorded before poo tracking existed carry no type, on the server and
// in the offline queue alike. Anything that is not an explicit poo is a pee.
export const normalizeType = (entry) => (entry && entry.type === 'poo' ? 'poo' : 'pee');
